function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin: 0.75rem 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
/**
 * Poll 컴포넌트를 위한 래퍼 스타일
 * Poll 컴포넌트가 이관되기 전까지 임시로 사용
 */ export var PollWrapper = styled.div(_templateObject());
